module.exports = __webpack_public_path__ + "img/pop_logo.7561d37b.jpg";